import { render, staticRenderFns } from "./SvgSectionsComponent.vue?vue&type=template&id=3c64ea37"
import script from "./SvgSectionsComponent.vue?vue&type=script&lang=js"
export * from "./SvgSectionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports